import ChatCreateGroup from '@/screens/ChatCreateGroup';

export default function PrivateChatCreateGroupIndexRoute() {
  return <ChatCreateGroup />;
}
